import "./centerdatecard.scss";
import { inject, observer } from "mobx-react";

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import moment from "moment";

registerLocale("ru", ru);

const CenterDateCard = ({
    setSelectedDate,
    selectedDate,
    setSelectedCenter,
    selectedCenter,
    selectedVacancy,
    vacancies,
    events,
    education_centers,
    updateCurrentVacancyId,
    updateCurrentCenterId,
    updateCurrentCenterTitle,
    updateCurrentDate,
}) => {
    const selectedDates = [null];
    const allDates = {};
    let selectedVacancyPosition;
    for (let i = 0; i < vacancies.length; ++i) {
        if (vacancies[i]["id"] === selectedVacancy) {
            selectedVacancyPosition = vacancies[i]["position_id"];
        }
    }
    selectedVacancyPosition &&
        events[selectedVacancyPosition] &&
        Object.entries(events[selectedVacancyPosition]).map((center) => {
            const id = center[0];
            allDates[id] = [];
            Object.entries(center[1]).map((item) => {
                const date = item[0];
                allDates[id].push(new Date(moment(date, "DD.MM.YYYY").format("YYYY/MM/DD")));
            });
        });

    return (
        <div className="centerdatecard">
            <div className="сenterdatecard__topcol">
                <p className="applications-small__card-text-subtitle">Город:</p>
                <div className="centerdatecard-radio">
                    {/* Оставить прежний УЦ можно только если вакансия не менялась:
                        у другой вакансии своё расписание центров и дат */}
                    {updateCurrentCenterId &&
                        selectedVacancy === updateCurrentVacancyId ? (
                        <label
                            htmlFor="keep-current-center"
                            className="educational-modal__main-checkboxes-item"
                        >
                            <input
                                type="radio"
                                id="keep-current-center"
                                name="centers"
                                defaultChecked={selectedCenter === updateCurrentCenterId}
                                onChange={() => {
                                    setSelectedCenter(updateCurrentCenterId);
                                    setSelectedDate(
                                        updateCurrentDate ? new Date(updateCurrentDate) : ""
                                    );
                                }}
                            />
                            Оставить прежний
                            {updateCurrentCenterTitle ? ` (${updateCurrentCenterTitle})` : ""}
                        </label>
                    ) : null}
                    {selectedVacancyPosition && events[selectedVacancyPosition] ? (
                        Object.entries(events[selectedVacancyPosition]).map((center) => {
                            // текущий центр уже показан пунктом "Оставить прежний"
                            if (
                                center[0] === updateCurrentCenterId &&
                                selectedVacancy === updateCurrentVacancyId
                            )
                                return null;
                            return (
                                <label
                                    key={education_centers[center[0]]["id"]}
                                    htmlFor={education_centers[center[0]]["id"]}
                                    className="educational-modal__main-checkboxes-item"
                                >
                                    <input
                                        type="radio"
                                        id={education_centers[center[0]]["id"]}
                                        name="centers"
                                        onChange={() => {
                                            setSelectedCenter(education_centers[center[0]]["id"]);
                                            setSelectedDate("");
                                        }}
                                    />
                                    г. {education_centers[center[0]]["title"]}
                                </label>
                            );
                        })
                    ) : (
                        <p className="applications-small__card-text-value">
                            Ни один учебеный центр не назначен . Пожалуйста, обратитесь к Вашему менеджеру за обновлением расписания.
                        </p>
                    )}
                </div>
            </div>

            <div className="сenterdatecard__col">
                <p className="applications-small__card-text-subtitle">Дата прибытия:</p>
                <>
                    {selectedCenter && !allDates[selectedCenter] ? (
                        // прежний центр вне расписания — доступна только прежняя дата
                        <DatePicker
                            inline
                            selected={selectedDate ? selectedDate : ""}
                            locale="ru"
                            onChange={(date) => {
                                setSelectedDate(date);
                            }}
                            includeDates={selectedDate ? [selectedDate] : []}
                            placeholderText="Дата прибытия"
                            disabledKeyboardNavigation
                        />
                    ) : selectedCenter ? (
                        <>
                            {Object.entries(allDates).map((center, i) => {
                                return selectedCenter === center[0] ? (
                                    <DatePicker
                                        key={i}
                                        inline
                                        selected={selectedDate ? selectedDate : ""}
                                        locale="ru"
                                        se
                                        onChange={(date) => {
                                            setSelectedDate(date);
                                        }}
                                        includeDates={center[1]}
                                        placeholderText="Дата прибытия"
                                        disabledKeyboardNavigation
                                    />
                                ) : (
                                    ""
                                );
                            })}
                        </>
                    ) : (
                        <DatePicker
                            inline
                            locale="ru"
                            includeDates={selectedDates}
                            placeholderText="Дата прибытия"
                            disabled
                            disabledKeyboardNavigation
                        />
                    )}
                </>
            </div>
        </div>
    );
};

export default inject(({ vacanciesStore, candidatesStore }) => {
    const { education_centers, setSelectedDate, selectedDate, setSelectedCenter, selectedCenter, selectedVacancy, updateCurrentVacancyId, updateCurrentCenterId, updateCurrentCenterTitle, updateCurrentDate } = candidatesStore;
    const { vacancies, events } = vacanciesStore;
    return {
        vacancies,
        events,
        education_centers,
        updateCurrentVacancyId,
        updateCurrentCenterId,
        updateCurrentCenterTitle,
        updateCurrentDate,
        setSelectedDate,
        selectedDate,
        setSelectedCenter,
        selectedCenter,
        selectedVacancy,
    };
})(observer(CenterDateCard));
